import { useCallback } from "react";
import MangeDashboard from "./ManageDashboard";
import { useMediaQuery } from "react-responsive";
import ItemsMoreMenu from "./ItemsMoreMenu";
import { useEffect } from "react";
import { useState } from "react";
import OfferList from "./OfferList";
import PriceBox from "./PriceBox";
import LogOut from "./LogOut";
import AfterLoginNav from "../AfterLoginNav";
import ScrollOnMainPage from "../ScrollOnMainPage";
import BottomHomeSlider from "../BottomHomeSlider";
import TotalAssetsMobile from "../TotalAssetsMobile";
import { useNavigate } from "react-router-dom";
import { getCurrentGoldPrice } from "../../services/gold-price";
import { getCurrentReport, getSystemContents } from "../../services/statistics";
import { getUserBalance } from "../../services/balance";
import { getGoldPriceHistory } from "../../services/gold-price";
import { toast } from "react-toastify";
import { Line } from "react-chartjs-2";
import FilterModal from "../FilterModal";
import CategoryModal from "../CategoryModal";
import BottomSheet from "../BottomSheet";
import TotalAssetsCommodityMobile from "./TotalAssetsCommodity";
import { getCommoditiesList } from "../../services/commodities";
import Products from "../../components/Products";
import { toPersianNum } from "../../utils/persianNumbers";
let activeOrderTmp = null;

export default function Hdash() {
  const [selectedChart, setSelectedChart] = useState(1);
  const [active, setActive] = useState("buy");
  const [commodities, setCommodities] = useState([]);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [activeTable, setActiveTable] = useState(1);
  const [prices, setPrices] = useState({});
  const [chartColor, setChartColor] = useState(null);
  const [activeOrder, setActiveOrder] = useState(null);
  const [userNumbers, setUsersNumber] = useState();
  const [tradeNumbers, setTradesNumber] = useState();
  const navigate = useNavigate();
  const [logouting, setLogouting] = useState(false);
  const [headerImage, setHeaderImage] = useState("");
  const [transactionAssets, setTransactionsAssets] = useState({});
  const [labels, setLabels] = useState([]);
  const [buyValues, setBuyValues] = useState([]);
  const [sellValues, setSellValues] = useState([]);
  const [activeChart, setActiveChart] = useState("buy");
  const [activate, setActivate] = useState(false);
  const [activateModal, setActivateModal] = useState(false);
  const [filterType, setFilterType] = useState(null);
  const [filterAmount, setFilterAmount] = useState(null);
  const [filterRange, setFilterRange] = useState(null);
  const [selectedCommodity, setSelectedCommodity] = useState({
    id: "",
    ui_data: { unit_name: "" },
  });
  const [commodityName, setCommodityName] = useState("");
  const actionButton = () => {
    return (
      <button className="action-bottom-sheet-button" onClick={filterItems}>
        اعمال فیلتر
      </button>
    );
  };
  function Openchanger(result) {
    setActivate(result);
  }
  function filterItems() {
    setActivate(false);
    setActiveOrder(activeOrderTmp);
  }
  const applyFilter = (type, amount, range) => {
    setFilterType(type);
    setFilterAmount(amount);
    setFilterRange(range);
    setActivateModal(false);
  };
  function getHistory() {
    getCommoditiesList().then((res) => {
      if (res.status === 200) {
        const data = res?.data?.results;
        if (data) {
          setSelectedCommodity(data[0]);
          setCommodities(data);
          const comName = data.find((el) => el.id === data[0].id).name;
          setCommodityName(comName);
        }
      }
    });
    getGoldPriceHistory()
      .then((res) => {
        if (res.status == 200) {
          if (res && res.data && res.data.results) {
            try {
              const tmpLabels = (res?.data?.results || []).map(
                (item) => (item?.created_at || "").split("T")[0]
              );
              const bValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              const sValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              setBuyValues(bValues);
              setSellValues(sValues);
              setLabels(tmpLabels);
            } catch (e) {}
          }
        } else {
          toast.error(res?.data?.detail);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail);
      });
  }
  useEffect(() => {
    getUserBalance().then(({ data }) => {
      if (data && data.data) {
        setTransactionsAssets(data.data);
      }
    });
  }, []);
  useEffect(() => {
    function fetchData() {
      getCurrentGoldPrice().then((goldPrice) => {
        if (goldPrice?.status == 200) {
          setPrices(goldPrice?.data?.data);
        }
        getCurrentReport().then((report) => {
          if (report?.status == 200) {
            let data = report?.data?.data;

            if (data) {
              setUsersNumber(data.registered_users_number);
              setTradesNumber(data.trades_number);
            }
          }
        });
        getSystemContents().then((res) => {
          if (res.status == 200) {
            let data = res?.data?.results;
            for (let item of data) {
              if (isTabletOrMobile) {
                if (item.key === "home_image") {
                  setHeaderImage(item.value);
                }
              } else {
                if (item.key === "platform_trade_tutorial") {
                  setHeaderImage(item.value);
                }
              }
            }
          }
        });
      });
    }
    fetchData();
  }, []);
  useEffect(() => {
    getHistory();
  }, []);
  const fetchSelectedChartInfo = useCallback(() => {
    getGoldPriceHistory(selectedChart)
      .then((res) => {
        if (res.status == 200) {
          try {
            if (res && res.data && res.data.results) {
              const tmpLabels = (res?.data?.results || []).map(
                (item) => (item?.created_at || "").split("T")[0]
              );
              const bValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              const sValues = (res?.data?.results || []).map(
                (item) => item.price
              );
              setBuyValues(bValues);
              setSellValues(sValues);
              setLabels(tmpLabels);
            }
          } catch (e) {}
        } else {
          toast.error(res?.data?.detail);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail);
      });
  }, [selectedChart]);
  useEffect(() => {
    if (selectedChart && !isNaN(selectedChart)) {
      fetchSelectedChartInfo();

      const selectedCommodityChart = commodities.find(
        (el) => el.id == selectedChart
      );
      if (selectedCommodityChart) {
        setChartColor(selectedCommodityChart?.ui_data?.colors?.primary);
      }
    }
  }, [selectedChart, commodities]);
  return (
    <>
      <MangeDashboard>
        <LogOut
          changeModalStatus={logouting}
          setChangeModalStatus={(st) => setLogouting(st)}
        />

        {isTabletOrMobile ? (
          <div className="main-dash">
            <AfterLoginNav title={"خانه"} />
            <div className="header-after-login-image">
              <div className="header-overlay" />
              <img src={headerImage} alt="" />
            </div>
            <div className="container margin-for-offer-container">
              <div className="row justify-content-center align-items-center">
                <div className="col-xl-8 col-md-8"></div>
                <div className="menu-items0012131">
                  <ItemsMoreMenu />
                </div>
                <div className="price-box-wrapper price-box-wrapper-home-mobile">
                  <PriceBox />
                </div>
                <ScrollOnMainPage />
                <div className="total-assets-mobile">
                  <TotalAssetsMobile />
                </div>
                <div className="total-assets-commodity">
                  <TotalAssetsCommodityMobile />
                </div>
                <div>
                  <Products isFull={true} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="content-for-home">
            <div className="header-for-login-after-layout">
              <img src={headerImage} alt={""} />
            </div>
            <div className="main-dash-desk">
              <ItemsMoreMenu />
              <div className="row">
                <div className="col-4">
                  <PriceBox />
                  <div className="total-asset-desktop">
                    <span className="smaller-items-amount-profit">
                      ارزش کل دارایی به لحظه
                      <br />
                      (موجودی تومانی + طلایی + نقره ای + زرینو)
                    </span>
                    <div className="price-items smaller-items-amount-desktop desktop-new-design-price">
                      <span>
                        {isNaN(transactionAssets?.total_assets)
                          ? new Intl.NumberFormat("fa", {
                              maximumFractionDigits: 0,
                            }).format(0)
                          : new Intl.NumberFormat("fa", {
                              maximumFractionDigits: 0,
                            }).format(transactionAssets?.total_assets)}
                        {"+"}
                      </span>
                    </div>
                  </div>
                  <div>
                    <button
                      className={"kharid-foroosh-btn"}
                      onClick={() => navigate("/trade-market")}
                    >
                      خرید / فروش
                    </button>
                  </div>
                </div>
                <div className="col-8">
                  <div className="select-box-items minimal-select">
                    {commodities.map((data) => (
                      <div
                        onClick={() => setSelectedChart(data.id)}
                        className={
                          selectedChart === data.id
                            ? "el-select-box"
                            : "el-select-box active-select-box"
                        }
                      >
                        {data.name}
                      </div>
                    ))}
                  </div>
                  {chartColor && buyValues && sellValues && (
                    <div className="line-chart-wrapper">
                      <Line
                        height={300}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          scales: {
                            y: {
                              beginAtZero: true,
                            },
                          },
                        }}
                        data={{
                          labels: labels,
                          datasets: [
                            {
                              label: `تاریخچه قیمت ${toPersianNum(
                                (commodities || []).find(
                                  (el) => el.id == selectedChart
                                )?.name
                              )}`,
                              data:
                                activeChart === "buy" ? buyValues : sellValues,
                              borderWidth: 1,
                              borderColor: chartColor,
                              fill: true,
                              pointBackgroundColor: chartColor,
                              backgroundColor: chartColor,
                              tension: 0.4,
                            },
                          ],
                        }}
                      />
                    </div>
                  )}
                  <div className="divider-to-two-wrapper">
                    <div className="content-for-stats">
                      <div>
                        <div>
                          <div className="title-for-trade-current-amount">
                            {!isNaN(userNumbers)
                              ? new Intl.NumberFormat("fa").format(userNumbers)
                              : new Intl.NumberFormat("fa").format(0)}
                          </div>

                          <div className="title-for-trade-plus-sign">+</div>
                          <div className="title-for-trade-current-amount smaller-amount-item">
                            کاربر تا امروز
                          </div>
                        </div>
                      </div>
                      <div className="second-box-stats">
                        <img src={"/images/trades-till-now.png"} alt={""} />
                      </div>
                      <div>
                        <div>
                          <div className="title-for-trade-current-amount">
                            {!isNaN(tradeNumbers)
                              ? new Intl.NumberFormat("fa").format(tradeNumbers)
                              : new Intl.NumberFormat("fa").format(0)}
                          </div>
                          <div className="title-for-trade-plus-sign">+</div>
                          <div className="title-for-trade-current-amount smaller-amount-item">
                            معامله تا امروز
                          </div>
                        </div>
                      </div>
                      <div className="second-box-stats">
                        <img src={"/images/current-user-box.png"} alt={""} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="margin-for-offer-lists lower-margin-for-offer-lists">
                <ScrollOnMainPage />
              </div>
              <div className="product-carousel-items">
                <Products />
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="filter-cat-row filter-cat-home">
                    <div onClick={() => setActivateModal(true)}>
                      <img src={"/images/svg/filters.svg"} alt={""} />
                      فیلترها
                    </div>
                    {filterAmount ||
                    (Array.isArray(filterRange) && filterRange.length > 0) ||
                    filterType === 0 ||
                    filterType === 1 ? (
                      <div
                        className="remove-filters filter-items-remove"
                        onClick={() => {
                          setFilterRange([]);
                          setFilterAmount(null);
                          setFilterType(null);
                        }}
                      >
                        &#10060;
                      </div>
                    ) : (
                      <></>
                    )}
                    <div onClick={() => setActivate(!activate)}>
                      <img src={"/images/svg/category.svg"} alt={""} />
                      دسته بندی ها
                    </div>
                    <select
                      className="select-commodity-item"
                      onChange={(e) => {
                        const filteredName = commodities.find(
                          (el) => el.id == e.target.value
                        );
                        setSelectedCommodity(filteredName);
                        setCommodityName(filteredName.name);
                      }}
                    >
                      {commodities.map((commodity) => (
                        <option value={commodity.id}>{commodity.name}</option>
                      ))}
                    </select>
                    {!isNaN(activeOrder) && activeOrder !== null && (
                      <div
                        className="remove-filters filter-items-remove"
                        onClick={() => {
                          setActiveOrder(null);
                        }}
                      >
                        &#10060;
                      </div>
                    )}
                  </div>
                  {isTabletOrMobile ? (
                    <BottomSheet
                      activate={activate}
                      actionButtons={actionButton}
                      onClose={() => setActivate(false)}
                    >
                      <>
                        <div className="select-box-row-sheet">
                          <input
                            id={"low-price-low-cap"}
                            type={"radio"}
                            onChange={() => (activeOrderTmp = 1)}
                            name="category-sheet-filter"
                          />
                          <label htmlFor="low-price-low-cap">
                            ارزان‌ترین قیمت در حجم کم
                          </label>
                        </div>
                        <div className="select-box-row-sheet">
                          <input
                            id={"low-price-high-cap"}
                            type={"radio"}
                            onChange={() => (activeOrderTmp = 2)}
                            name="category-sheet-filter"
                          />
                          <label htmlFor={"low-price-high-cap"}>
                            ارزان‌ترین قیمت در حجم زیاد
                          </label>
                        </div>
                        <div className="select-box-row-sheet">
                          <input
                            id={"high-price-low-cap"}
                            type={"radio"}
                            onChange={() => (activeOrderTmp = 3)}
                            name="category-sheet-filter"
                          />
                          <label htmlFor={"high-price-low-cap"}>
                            گرانترین قیمت در حجم کم
                          </label>
                        </div>
                        <div className="select-box-row-sheet">
                          <input
                            id={"high-price-high-cap"}
                            type={"radio"}
                            onChange={() => (activeOrderTmp = 4)}
                            name="category-sheet-filter"
                          />
                          <label htmlFor={"high-price-high-cap"}>
                            گرانترین قیمت در حجم زیاد
                          </label>
                        </div>
                      </>
                    </BottomSheet>
                  ) : (
                    <CategoryModal
                      setActiveOrder={(order) => setActiveOrder(order)}
                      modalIsOpen={activate}
                      Openchanger={Openchanger}
                    />
                  )}
                  {activateModal && (
                    <FilterModal
                      closeModal={() => setActivateModal(false)}
                      applyFilter={applyFilter}
                    />
                  )}
                </div>
                <div className="col-6">
                  <div className="filters-items-home">
                    <button
                      className={"form-input-button-custom-home"}
                      onClick={() => setActiveTable(1)}
                    >
                      پیشنهادهای خرید کاربران
                    </button>
                    <div className="offer-list-on-home">
                      <OfferList
                        activeOffer={(active) => setActive(active)}
                        activeOrder={activeOrder}
                        filterType={filterType}
                        filterAmount={filterAmount}
                        filterRange={filterRange}
                        selectedCommodity={selectedCommodity}
                        setActiveTable={(active) => setActiveTable(active)}
                        orderList={(item) => {
                          navigate(
                            "/limit-order?type=sell&order=" +
                              item.id +
                              "&commodity_id=" +
                              selectedCommodity.id
                          );
                        }}
                        activeTable={1}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="filters-items-home">
                    <button className={"form-input-button-custom-home"}>
                      پیشنهادهای فروش کاربران
                    </button>
                    <div className="offer-list-on-home">
                      <OfferList
                        activeOffer={(active) => setActive(active)}
                        activeOrder={activeOrder}
                        filterType={filterType}
                        filterAmount={filterAmount}
                        filterRange={filterRange}
                        selectedCommodity={selectedCommodity}
                        setActiveTable={(active) => setActiveTable(active)}
                        orderList={(item) => {
                          navigate(
                            "/limit-order?type=buy" +
                              "&order=" +
                              item.id +
                              "&commodity_id=" +
                              selectedCommodity.id
                          );
                        }}
                        activeTable={2}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-more-items-bottom">
              <div className="main-dash-desk">
                <BottomHomeSlider />
              </div>
            </div>
          </div>
        )}
      </MangeDashboard>
    </>
  );
}
